const STORAGE_BASE = "https://api.uktomars.co.uk/storage";

function resolveImagePath(value) {
  if (!value || typeof value !== "string") return "";
  if (value.startsWith("http")) return value;
  return `${STORAGE_BASE}/${value.replace(/^\/+/, "")}`;
}

function str(value) {
  if (value == null || value === "") return "";
  return String(value);
}

/**
 * Maps an API product to the shape stored in the Redux cart.
 */
export function productToCartItem(product, getImage) {
  const imagePath = str(product?.image);
  const imageUrl = str(product?.image_url) || resolveImagePath(product?.image);
  const image = typeof getImage === "function" ? getImage(product) : imageUrl;
  const rawPrice = product?.price;
  const price =
    rawPrice != null && rawPrice !== "" ? String(rawPrice).trim() : "";

  return {
    id: product.id,
    name: str(product?.name),
    slug: str(product?.slug),
    sku: str(product?.sku),
    code: str(product?.code),
    image: imagePath || image,
    image_url: imageUrl || image,
    description: str(product?.description),
    ingredients: str(product?.ingredients),
    price,
    unit: str(product?.unit),
    case_size: str(product?.case_size),
    layer: product?.layer ?? "",
    pallet: product?.pallet ?? "",
    unit_barcode: str(product?.unit_barcode),
    case_barcode: str(product?.case_barcode),
    net_weight: str(product?.net_weight),
    vat: str(product?.vat),
  };
}
